import { createFileRoute } from "@tanstack/react-router"

import { FunctionCoveragePanel } from "@/pages/FunctionCoveragePanel"

export const Route = createFileRoute("/administration/functions")({
  component: FunctionCoveragePanel,
})
